import AbstractTimezone from './AbstractTimezone';
import TimezoneBtn from './component/TimezoneBtn';
import TimezoneLayer from './component/TimezoneLayer';

class TimezoneBtnLayer extends AbstractTimezone {
  timezoneBtn!: TimezoneBtn;

  timezoneLayer!: TimezoneLayer;

  render() {
    this.timezoneBtn = new TimezoneBtn(this.config, this.emitter);
    this.$parent?.append(this.timezoneBtn?.element);

    this.timezoneLayer = new TimezoneLayer(this.config, this.emitter);
    this.content.element && this.timezoneLayer?.contentElement?.append(this.content.element);
    
    this.$parent?.append(this.timezoneLayer?.element);
  }

  addEvent() {
    this.emitter.addEvent('CLICK_TIMEZONE_BTN', (isActive: boolean) => {
      isActive ? this.timezoneLayer.open() : this.timezoneLayer.close();
    });

    this.emitter.addEvent('TOGGLE_OPEN_LAYER', (isOpen: boolean) => {
      isOpen ? this.content.update() : this.content.destroy();
      this.emitter.emit('CHANGE_BTN_ISACTIVE', isOpen);
    });
  }
}

export default TimezoneBtnLayer;